import { apiPrefixes } from '@/api/apiPrefixes'
import { http, cookies, isRkhy } from '@/utils'
import qs from 'query-string'

const api = {
  queryUserInfo: `${apiPrefixes.userapi}/user/GetUserInfo`,
  queryShareKey: `${apiPrefixes.mallbackapi}/share/commercialInterface/getKey.do`
}

export async function queryUserInfo({
  visitkey,
  padetail,
  pregnant
}: any = {}) {
  try {
    const uid = cookies.get('uid')
    const skey = cookies.get('skey')
    if (!uid || !skey) {
      return null
    }
    const query = qs.stringify({
      uid,
      skey,
      visitkey,
      padetail,
      pregnant
    })
    const result: any = await http.get(`${api.queryUserInfo}?${query}`)
    if (result.errno === 0) {
      return result.data || null
    } else {
      return null
    }
  } catch (e) {
    return null
  }
}

export async function queryShareKey() {
  const uid = cookies.get('uid')
  if (!uid) {
    return ''
  }
  const rkhy = isRkhy()
  try {
    const jsonobj = {
      uid,
      commercialname: '孩子王',
      token: 'YjYphjJdS5RzGiOoQmnApw==',
      ip: '1.1.1.1',
      utype: rkhy ? 1 : 2,
      linkcontentid: encodeURIComponent(location.href),
      accessterminal: rkhy ? 1 : 2,
      isShort: 'true',
      linktype: rkhy ? 24 : 2
    }
    const url = `${api.queryShareKey}?jsonobj=${encodeURI(
      JSON.stringify(jsonobj)
    )}`
    const res: any = await http.get(url)
    if (+res.result === 0) {
      return res.data || ''
    } else {
      return ''
    }
  } catch (error) {
    return ''
  }
}
